"use client";

import { useEffect } from "react";
import { amplitudeTrackEvent } from "@/services/Amplitude";

interface AmplitudeEventClientProps {
  event: string;
  eventContent?: string;
}

const AmplitudeEventClient: React.FC<AmplitudeEventClientProps> = ({ event, eventContent }) => {
  useEffect(() => {
    amplitudeTrackEvent(event, {
      content: eventContent,
    });
  }, [event, eventContent]);

  return null;
};

export default AmplitudeEventClient;
